import React from "react";
import useTranslationRepository from "./use-translation-repository";

export default function useOnLocaleLoaded(callback) {

    const repository = useTranslationRepository();

    React.useEffect(() => {
        repository.onLoaded(callback);

        return () => {
            repository.removeOnLoaded(callback);
        };
    }, []);

}
